<alarms type="active"></alarms>
